/*
 *
 * SplitSchemeConfiguration actions
 *
 */

import {
  DEFAULT_ACTION,
  ENABLE_LOADER,
  DISABLE_LOADER,
  SEARCH_CONFIGURATIONS,
  SAVE_CONFIGURATIONS,
  UPDATE_FILTERS,
  UPDATE_TABLE_DATA,
  CREATE_SPLIT_SCHEME,
  DELETE_SPLIT_SCHEME,
  GET_ALL_TERMINAL_ID,
  SAVE_ALL_TERMINAL_ID,
  GET_VENDOR_BY_ID,
  GET_STATIC_SPLIT_STATUS,
  SAVE_STATIC_SPLIT_STATUS,
} from './constants';

export function defaultAction() {
  return {
    type: DEFAULT_ACTION,
  };
}

export function getStaticSplitStatusAction() {
  return {
    type: GET_STATIC_SPLIT_STATUS,
  };
}

export function saveStaticSplitStatusAction(data) {
  return {
    type: SAVE_STATIC_SPLIT_STATUS,
    data,
  };
}

export function searchConfigurationsAction(data) {
  return {
    type: SEARCH_CONFIGURATIONS,
    data,
  };
}

export function saveConfigurationsAction(data) {
  return {
    type: SAVE_CONFIGURATIONS,
    data,
  };
}

export function updateTableDataAction(data) {
  return {
    type: UPDATE_TABLE_DATA,
    data,
  };
}

export function updateFiltersAction(data) {
  return {
    type: UPDATE_FILTERS,
    data,
  };
}

export function enableLoaderAction() {
  return {
    type: ENABLE_LOADER,
  };
}

export function disableLoaderAction() {
  return {
    type: DISABLE_LOADER,
  };
}

export function createSchemeAction(data) {
  return {
    type: CREATE_SPLIT_SCHEME,
    data,
  };
}

export function deleteSchemeAction(data) {
  return {
    type: DELETE_SPLIT_SCHEME,
    data,
  };
}

export function getTerminalIdAction(data) {
  return {
    type: GET_ALL_TERMINAL_ID,
    data,
  };
}

export function saveTerminalIdAction(data) {
  return {
    type: SAVE_ALL_TERMINAL_ID,
    data,
  };
}

export function verifyVendorByIdAction(data) {
  return {
    type: GET_VENDOR_BY_ID,
    data,
  };
}
